export default __webpack_public_path__ + "static/media/IconDesc_CircuitBoard.256.e979e7a2.png";